import React from "react";

export default function About() {
  return (
    <div>
      <div
        id="features-hcTzKN"
        className="px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto font-energetic bg-black"
      >
        <div className="relative bg-bg-black max-w-screen-2xl m-auto">
          <div className="relative flex w-full flex-col lg:flex-row items-center justify-center gap-4 lg:gap-12 flex-col lg:flex-row-reverse">
            <div className="mb-10 lg:mb-0 lg:col-span-6 lg:col-start-8 w-full lg:w-1/2 ">
              <h2 className="text-2xl text-white font-bold sm:text-3xl">
                Why Radio O?
              </h2>
              <nav
                className="grid lg:mt-5 md:mt-10 gap-5"
                aria-label="Tabs"
                role="tablist"
              >
                <button
                  type="button"
                  className="hover:bg-gray-800 hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start p-4 md:p-5 rounded-xl dark:focus:outline-none dark:focus:ring-1 active"
                  id="tabs-with-card-item-1"
                  data-hs-tab="#tabs-with-card-1"
                  aria-controls="tabs-with-card-1"
                  role="tab"
                >
                  <span className="flex">
                    <span className="">
                      <span className="block text-lg font-semibold text-white text-left">
                        Our Mission
                      </span>
                      <span className="block mt-1 text-gray-400">
                        Radio O's Mission is to bless lives using the power of the airwaves
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  className="hover:bg-gray-800 hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start p-4 md:p-5 rounded-xl dark:focus:outline-none dark:focus:ring-1 active"
                  id="tabs-with-card-item-1"
                  data-hs-tab="#tabs-with-card-1"
                  aria-controls="tabs-with-card-1"
                  role="tab"
                >
                  <span className="flex">
                    <span className="">
                      <span className="block text-lg font-semibold text-white text-left">
                        Our Vision
                      </span>
                      <span className="block mt-1 text-gray-400">
                        Radio's Vision is to bring about transformational and society change using the instrument of gospel music
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  className="hover:bg-gray-800 hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start p-4 md:p-5 rounded-xl dark:focus:outline-none dark:focus:ring-1 active"
                  id="tabs-with-card-item-1"
                  data-hs-tab="#tabs-with-card-1"
                  aria-controls="tabs-with-card-1"
                  role="tab"
                >
                  <span className="flex">
                    <span className="">
                      <span className="block text-lg font-semibold text-white text-left">
                        Manchester’s Voice
                      </span>
                      <span className="block mt-1 text-gray-400">
                        Broadcasting the city’s culture, talent, and stories.
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  className="hover:bg-gray-800 hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start p-4 md:p-5 rounded-xl dark:focus:outline-none dark:focus:ring-1 active"
                  id="tabs-with-card-item-1"
                  data-hs-tab="#tabs-with-card-1"
                  aria-controls="tabs-with-card-1"
                  role="tab"
                >
                  <span className="flex">
                    <span className="grow">
                      <span className="block text-lg font-semibold text-white text-left">
                        Live 24/7
                      </span>
                      <span className="block mt-1 text-gray-400">
                        Never miss a beat — music, talk, and vibes around the
                        clock.
                      </span>
                    </span>
                  </span>
                </button>
                <button
                  type="button"
                  className="hover:bg-gray-800 hs-tab-active:shadow-md hs-tab-active:hover:border-transparent text-start p-4 md:p-5 rounded-xl dark:focus:outline-none dark:focus:ring-1 active"
                  id="tabs-with-card-item-1"
                  data-hs-tab="#tabs-with-card-1"
                  aria-controls="tabs-with-card-1"
                  role="tab"
                >
                  <span className="flex">
                    <span className="grow">
                      <span className="block text-lg font-semibold text-white text-left">
                        Tune In Anywhere
                      </span>
                      <span className="block mt-1 text-gray-400">
                        Available worldwide — just press play.
                      </span>
                    </span>
                  </span>
                </button>
              </nav>
            </div>
            <div className=" w-full lg:w-1/2">
              <div className="relative w-full">
                <div>
                  <div
                    id="tabs-with-card-1"
                    className="tabpanel"
                    aria-labelledby="tabs-with-card-item-1"
                  >
                    <img
                      className="shadow-xl shadow-gray-800 max-h-[550px] rounded-xl dark:shadow-gray-900/[.2]"
                      src="https://images.pexels.com/photos/6919956/pexels-photo-6919956.jpeg"
                      alt="Hero"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
